@file:Suppress("unused", "SpellCheckingInspection")

package xim.poc.game.configuration.constants

const val weaponBilbo_16512 = 16512
const val weaponTuck_16513 = 16513
const val weaponMailbreaker_16514 = 16514
const val weaponColichemarde_16515 = 16515
const val weaponJrMskTuck_16516 = 16516
const val weaponDegen_16517 = 16517
const val weaponMythrilDegen_16518 = 16518
const val weaponSchlaeger_16519 = 16519
const val weaponVerdun_16520 = 16520
const val weaponRapier_16521 = 16521
const val weaponFlameDegen_16522 = 16522
const val weaponHolyDegen_16523 = 16523
const val weaponFleuret_16524 = 16524
const val weaponHornetFleuret_16525 = 16525
const val weaponSchwert_16526 = 16526
const val weaponEpee_16527 = 16527
const val weaponBloodyRapier_16528 = 16528
const val weaponMusketeersSword_16529 = 16529
const val weaponXiphos_16530 = 16530
const val weaponBrassXiphos_16531 = 16531
const val weaponGladius_16532 = 16532
const val weaponAncientSword_16533 = 16533
const val weaponOnionSword_16534 = 16534
const val weaponBronzeSword_16535 = 16535
const val weaponIronSword_16536 = 16536
const val weaponMythrilSword_16537 = 16537
const val weaponDarksteelSword_16538 = 16538
const val weaponCermetSword_16539 = 16539
const val weaponTyrfing_16540 = 16540
const val weaponJagdplaute_16541 = 16541
const val weaponWingSword_16542 = 16542
const val weaponFireSword_16543 = 16543
const val weaponRylArcSword_16544 = 16544
const val weaponBroadsword_16545 = 16545
const val weaponKatzbalger_16546 = 16546
const val weaponAnelace_16547 = 16547
const val weaponCoralSword_16548 = 16548
const val weaponDivineSword_16549 = 16549
const val weaponHallowedSword_16550 = 16550
const val weaponSapara_16551 = 16551
const val weaponScimitar_16552 = 16552
const val weaponTulwar_16553 = 16553
const val weaponHanger_16554 = 16554
const val weaponRidill_16555 = 16555
const val weaponBloodyBlade_16556 = 16556
const val weaponMskCmdFalchion_16557 = 16557
const val weaponFalchion_16558 = 16558
const val weaponDarksteelFalchion_16559 = 16559
const val weaponCutlass_16560 = 16560
const val weaponPlatinumCutlass_16562 = 16562
const val weaponRuneBlade_16563 = 16563
const val weaponFlameBlade_16564 = 16564
const val weaponSpatha_16565 = 16565
const val weaponLongsword_16566 = 16566
const val weaponKnightsSword_16567 = 16567
const val weaponSaber_16568 = 16568
const val weaponGoldSword_16569 = 16569
const val weaponTKArmySword_16571 = 16571
const val weaponBeeSpatha_16572 = 16572
const val weaponCurtana_16575 = 16575
const val weaponHuntingSword_16576 = 16576
const val weaponBastardSword_16577 = 16577
const val weaponEspadon_16578 = 16578
const val weaponKaskara_16579 = 16579
const val weaponBloodsword_16580 = 16580
const val weaponHolySword_16581 = 16581
const val weaponVetalaSword_16582 = 16582
const val weaponWaxSword_16600 = 16600
const val weaponSavetheQueen_16604 = 16604
const val weaponEnhancingSword_16605 = 16605
const val weaponGladiator_16608 = 16608
const val weaponBloodySword_16609 = 16609
const val weaponWaxSword1_16610 = 16610
const val weaponBeeSpatha1_16611 = 16611
const val weaponSaber1_16612 = 16612
const val weaponSpiritSword_16613 = 16613
const val weaponFalchion1_16615 = 16615
const val weaponTuck1_16617 = 16617
const val weaponMailbreaker1_16618 = 16618
const val weaponEpee1_16619 = 16619
const val weaponMermansSword_16620 = 16620
const val weaponFlameSword_16621 = 16621
const val weaponBronzeSword1_16623 = 16623
const val weaponXiphos1_16624 = 16624
const val weaponScimitar1_16625 = 16625
const val weaponIronSword1_16626 = 16626
const val weaponSpatha1_16627 = 16627
const val weaponLongsword1_16628 = 16628
const val weaponSmallSword_16629 = 16629
const val weaponStrikerSword_16630 = 16630
const val weaponKaiserSword_16631 = 16631
const val weaponBilbo1_16632 = 16632
const val weaponDegen1_16633 = 16633
const val weaponBroadsword1_16634 = 16634
const val weaponMythrilSword1_16635 = 16635
const val weaponTulwar1_16636 = 16636
const val weaponKnightsSword1_16800 = 16800
const val weaponSapara1_16801 = 16801
const val weaponBrassXiphos1_16802 = 16802
const val weaponFleuret1_16803 = 16803
const val weaponFlameBlade1_16804 = 16804
const val weaponRylGrdFleuret_16805 = 16805
const val weaponCenturionsSword_16806 = 16806
const val weaponCmbCstScimitar_16807 = 16807
const val weaponWisWizBilbo_16808 = 16808
const val weaponWisWizAnelace_16809 = 16809
const val weaponTctMagEspadon_16810 = 16810
const val weaponDstSword1_16811 = 16811
const val weaponWarSword_16812 = 16812
const val weaponSchlaeger1_16813 = 16813
const val weaponCrescentSword_16814 = 16814
const val weaponMythrilDegen1_16815 = 16815
const val weaponHolySword1_16816 = 16816
const val weaponHolyDegen1_16817 = 16817
const val weaponSandOrianSword_16818 = 16818
const val weaponMithranScimitar_16819 = 16819
const val weaponStriderSword_16820 = 16820
const val weaponDuelRapier_16821 = 16821
const val weaponCrimsonBlade_16822 = 16822
const val weaponFlameDegen1_16823 = 16823
const val weaponCarnageRapier_16824 = 16824
const val weaponCermetSword1_16825 = 16825
const val weaponDivineSword1_16826 = 16826
const val weaponCarnageBlade_16827 = 16827
const val weaponBastardSword1_16828 = 16828
const val weaponFencingDegen_16829 = 16829
const val weaponGluttonySword_16830 = 16830
const val weaponGreedScimitar_16831 = 16831
const val weaponMoonringBlade1_17279 = 17279
const val weaponBoomerang_17280 = 17280
const val weaponWingedge_17281 = 17281
const val weaponCmbCstBmerang_17282 = 17282
const val weaponJrMskChakram_17283 = 17283
const val weaponChakram_17284 = 17284
const val weaponMoonringBlade_17285 = 17285
const val weaponRisingSun_17286 = 17286
const val weaponBoomerang1_17287 = 17287
const val weaponWingedge1_17288 = 17288
const val weaponChakram1_17289 = 17289
const val weaponCoarseBoomerang_17290 = 17290
const val weaponFlameBoomerang_17291 = 17291
const val weaponLongBoomerang_17292 = 17292
const val weaponYagudoFreezer_17293 = 17293
const val weaponCometTail_17294 = 17294
const val weaponRisingSun1_17295 = 17295
const val weaponPebble_17296 = 17296
const val weaponThrowingCoin_17297 = 17297
const val weaponTathlum_17298 = 17298
const val weaponAstragalos_17299 = 17299
const val weaponShuriken_17301 = 17301
const val weaponJujiShuriken_17302 = 17302
const val weaponManjiShuriken_17303 = 17303
const val weaponFumaShuriken_17304 = 17304
const val weaponClusterArm_17305 = 17305
const val weaponSnollArm_17306 = 17306
const val weaponDart_17307 = 17307
const val weaponHawkeye_17308 = 17308
const val weaponPinwheel_17309 = 17309
const val weaponHyo_17310 = 17310
const val weaponDart1_17311 = 17311
const val weaponGrenade_17313 = 17313
const val weaponQuakeGrenade_17314 = 17314
const val weaponRiotGrenade_17315 = 17315
const val weaponBombArm_17316 = 17316
const val weaponColichemarde1_17632 = 17632
const val weaponRapier1_17633 = 17633
const val weaponWaspFleuret_17634 = 17634
const val weaponSchwert1_17635 = 17635
const val weaponJagdplaute1_17636 = 17636
const val weaponWingSword1_17637 = 17637
const val weaponKatzbalger1_17638 = 17638
const val weaponCutlass1_17639 = 17639
const val weaponPtmCutlass1_17640 = 17640
const val weaponGoldSword1_17641 = 17641
const val weaponHanger1_17642 = 17642
const val weaponHonorSword_17643 = 17643
const val weaponJudgesSword_17644 = 17644
const val weaponEspadon1_17645 = 17645
const val weaponCarnageSword_17646 = 17646
const val weaponAramissRapier_17647 = 17647
const val weaponDragvandil_17648 = 17648
const val weaponNightmareSword_17649 = 17649
const val weaponNadrs_17650 = 17650
const val weaponDainslaif_17651 = 17651
const val weaponJoyeuse_17652 = 17652
const val weaponHrotti_17653 = 17653
const val weaponSaparaofTrials_17654 = 17654
const val weaponSnrMskScimitar_17655 = 17655
const val weaponVerdun1_17656 = 17656
const val weaponAnelace1_17657 = 17657
const val weaponTutelary_17658 = 17658
const val weaponSeiryusSword_17659 = 17659
const val weaponKilij_17660 = 17660
const val weaponStormScimitar_17661 = 17661
const val weaponCompanySword_17662 = 17662
const val weaponKilij1_17663 = 17663
const val weaponFirmament_17664 = 17664
const val weaponIfritsBlade_17665 = 17665
const val weaponJrMskTuck1_17666 = 17666
const val weaponJrMskTuck2_17667 = 17667
const val weaponFirmament1_17668 = 17668
const val weaponSagasinger_17669 = 17669
const val weaponTKSword1_17670 = 17670
const val weaponTKSword2_17671 = 17671
const val weaponBastokanSword_17672 = 17672
const val weaponRepublicSword_17673 = 17673
const val weaponCmbCstScmtr1_17674 = 17674
const val weaponCmbCstScmtr2_17675 = 17675
const val weaponTMEspadon1_17676 = 17676
const val weaponTMEspadon2_17677 = 17677
const val weaponSandOrianSword_17678 = 17678
const val weaponKingdomSword_17679 = 17679
const val weaponMskSword1_17680 = 17680
const val weaponMskSword2_17681 = 17681
const val weaponSacredSword_17682 = 17682
const val weaponSacredDegen_17683 = 17683
const val weaponGriffinclaw_17684 = 17684
const val weaponLexTalionis_17685 = 17685
const val weaponSparkBilbo_17686 = 17686
const val weaponSparkBilbo1_17687 = 17687
const val weaponSparkDegen_17688 = 17688
const val weaponSparkDegen1_17689 = 17689
const val weaponSparkRapier_17690 = 17690
const val weaponSparkRapier1_17691 = 17691
const val weaponPlatoonSpatha_17692 = 17692
const val weaponGrudgeSword_17693 = 17693
const val weaponGuespiere_17694 = 17694
const val weaponBayardsSword_17695 = 17695
const val weaponBuzzardTuck_17696 = 17696
const val weaponMightyTalwar_17697 = 17697
const val weaponPrincelySword_17698 = 17698
const val weaponDissector_17699 = 17699
const val weaponDurandal_17700 = 17700
const val weaponShotel_17701 = 17701
const val weaponShotel1_17702 = 17702
const val weaponPealingAnelace_17703 = 17703
const val weaponVulcanSword_17704 = 17704
const val weaponVulcanDegen_17705 = 17705
const val weaponVulcanBlade_17706 = 17706
const val weaponMartialAnelace_17707 = 17707
const val weaponAurigaXiphos_17708 = 17708
const val weaponSwanBilbo_17709 = 17709
const val weaponJusticeSword_17710 = 17710
const val weaponShivasShotel_17711 = 17711
const val weaponKaskara1_17712 = 17712
const val weaponMacuahuitl_17713 = 17713
const val weaponMacuahuitl1_17714 = 17714
const val weaponStormTulwar_17715 = 17715
const val weaponMacuahuitl1_17716 = 17716
const val weaponImmortalsScimitar_17717 = 17717
const val weaponLeechScimitar_17718 = 17718
const val weaponMensurEpee_17719 = 17719
const val weaponCompanyFleuret_17720 = 17720
const val weaponSanguineSword_17721 = 17721
const val weaponPhantomFleuret_17722 = 17722
const val weaponSinghKilij_17723 = 17723
const val weaponDarksteelKilij_17724 = 17724
const val weaponDarksteelKilij1_17725 = 17725
const val weaponImmortalsShotel_17726 = 17726
const val weaponAdamanKilij_17727 = 17727
const val weaponAdamanKilij1_17728 = 17728
const val weaponVerminSlayer_17729 = 17729
const val weaponInsectSlayer_17730 = 17730
const val weaponAquanSlayer_17731 = 17731
const val weaponMarineSlayer_17732 = 17732
const val weaponDragonSlayer_17733 = 17733
const val weaponWyrmSlayer_17734 = 17734
const val weaponDemonSlayer_17735 = 17735
const val weaponDevilSlayer_17736 = 17736
const val weaponCorsairsScimitar_17737 = 17737
const val weaponHauteclaire_17738 = 17738
const val weaponSteelKilij_17739 = 17739
const val weaponSteelKilij1_17740 = 17740
const val weaponPerduHanger_17741 = 17741
const val weaponVorpalSword_17742 = 17742
const val weaponWightslayer_17743 = 17743
const val weaponBraveBlade_17744 = 17744
const val weaponHofud_17745 = 17745
const val weaponCermetKilij_17746 = 17746
const val weaponCermetKilij1_17747 = 17747
const val weaponIbushiShinai_17748 = 17748
const val weaponIbushiShinai1_17749 = 17749
const val weaponAnthosXiphos_17750 = 17750
const val weaponFragarach_17751 = 17751
const val weaponOrganics_17753 = 17753
const val weaponSylphidEpee_17754 = 17754
const val weaponBeastSlayer_17755 = 17755
const val weaponSinfender_17756 = 17756
const val weaponMerveilleuse_17757 = 17757
const val weaponRuler_17758 = 17758
const val weaponKoggelmander_17759 = 17759
const val weaponBucScimitar_17760 = 17760
const val weaponOberonsRapier_17761 = 17761
const val weaponErlkingsSword_17762 = 17762
const val weaponErlkingsBlade_17763 = 17763
const val weaponTraineeSword_17764 = 17764
const val weaponConcordia_17765 = 17765
const val weaponLyftScimitar_17766 = 17766
const val weaponChippedScimitar_17767 = 17767
const val weaponCmbCstBmrng1_18132 = 18132
const val weaponCmbCstBmrng2_18133 = 18133
const val weaponJrMskChakram1_18134 = 18134
const val weaponJrMskChakram2_18135 = 18135
const val weaponUngurBoomerang_18141 = 18141
const val weaponArcticWind_18161 = 18161
const val weaponEastWind_18162 = 18162
const val weaponZephyr_18163 = 18163
const val weaponAntarcticWind_18164 = 18164
const val weaponImperialEgg_18168 = 18168
const val weaponTsarsEgg_18169 = 18169
const val weaponPlatoonEdge_18170 = 18170
const val weaponPlatoonDisc_18171 = 18171
const val weaponLightBoomerang_18172 = 18172
const val weaponNokizaruShuriken_18173 = 18173
const val weaponDeathChakram_18231 = 18231
const val weaponAureole_18245 = 18245
const val weaponRogetsurin_18246 = 18246
const val weaponRelicSword_18272 = 18272
const val weaponGlypticSword_18273 = 18273
const val weaponDynamisSword_18274 = 18274
const val weaponCaliburn_18275 = 18275
const val weaponExcalibur_18276 = 18276
const val weaponExcalibur_18277 = 18277
const val weaponBonanzaBall_18468 = 18468
const val weaponExcalibur_18639 = 18639
const val weaponExcalibur_18653 = 18653
const val weaponExcalibur_18667 = 18667
const val weaponAhtUrhganDart_18681 = 18681
const val weaponMamoolbane_18692 = 18692
const val weaponLamiabane_18693 = 18693
const val weaponTrollbane_18694 = 18694
const val weaponSnakeeye_18708 = 18708
const val weaponSnakeeye1_18709 = 18709
const val weaponKogaShuriken_18712 = 18712
const val weaponPeisteDart_18726 = 18726
const val weaponDjinnArm_18729 = 18729
const val weaponHannibalsSword_18891 = 18891
const val weaponCorbenicSword_18892 = 18892
const val weaponMagnusSword_18893 = 18893
const val weaponAccoladeSword_18894 = 18894
const val weaponChimericFleuret_18895 = 18895
const val weaponHonorbound_18896 = 18896
const val weaponIsador_18897 = 18897
const val weaponMageblade_18898 = 18898
const val weaponRunicAnelace_18899 = 18899
const val weaponSkeldSword_18900 = 18900
const val weaponFalcata_18901 = 18901
const val weaponFalcata1_18902 = 18902
const val weaponTalekeeper_18903 = 18903
const val weaponEphemeron_18904 = 18904
const val weaponSwiftwing_18905 = 18905
const val weaponGalenus_18906 = 18906
const val weaponDevourer_18907 = 18907
const val weaponDhampyrSword_18908 = 18908
const val weaponSanusEnsis_18909 = 18909
const val weaponApaisante_18910 = 18910
const val weaponApaisante1_18911 = 18911
const val weaponArkSaber_18912 = 18912
const val weaponArkSword_18913 = 18913
const val weaponKillersKilij_18914 = 18914
const val weaponEradicatorsKilij_18915 = 18915
const val weaponHeimdallsDoom_18916 = 18916
const val weaponMurgleis_18975 = 18975
const val weaponBurtgang_18977 = 18977
const val weaponTizona_18986 = 18986
const val weaponMurgleis_18995 = 18995
const val weaponBurtgang_18997 = 18997
const val weaponTizona_19006 = 19006
const val weaponMurgleis_19064 = 19064
const val weaponBurtgang_19066 = 19066
const val weaponTizona_19075 = 19075
const val weaponMurgleis_19084 = 19084
const val weaponBurtgang_19086 = 19086
const val weaponTizona_19095 = 19095
const val weaponSmartGrenade_19202 = 19202
const val weaponWarHoop_19203 = 19203
const val weaponStygianAsh_19210 = 19210
const val weaponRaidersBmrng_19260 = 19260
const val weaponJinxDiscus_19261 = 19261
const val weaponSidesword_19337 = 19337
const val weaponSchiavona_19338 = 19338
const val weaponNobilis_19339 = 19339
const val weaponAntea_19340 = 19340
const val weaponSoulsaber_19341 = 19341
const val weaponAlmace_19399 = 19399
const val weaponBadelaire_19420 = 19420
const val weaponKhanda_19421 = 19421
const val weaponShamshir_19422 = 19422
const val weaponMachaera_19423 = 19423
const val weaponAlmace_19458 = 19458
const val weaponBadelaire1_19478 = 19478
const val weaponKhanda1_19479 = 19479
const val weaponShamshir1_19480 = 19480
const val weaponMachaera1_19481 = 19481
const val weaponAlmace_19536 = 19536
const val weaponBadelaire2_19556 = 19556
const val weaponKhanda2_19557 = 19557
const val weaponShamshir2_19558 = 19558
const val weaponMachaera2_19559 = 19559
const val weaponMurgleis_19616 = 19616
const val weaponBurtgang_19618 = 19618
const val weaponTizona_19627 = 19627
const val weaponAlmace_19634 = 19634
const val weaponBadelaire3_19654 = 19654
const val weaponKhanda3_19655 = 19655
const val weaponShamshir3_19656 = 19656
const val weaponMachaera3_19657 = 19657
const val weaponMurgleis_19714 = 19714
const val weaponBurtgang_19716 = 19716
const val weaponTizona_19725 = 19725
const val weaponExcalibur_19748 = 19748
const val weaponEgoistTathlum_19768 = 19768
const val weaponAliyatChakram_19770 = 19770
const val weaponIgaShuriken_19783 = 19783
const val weaponAlmace_19807 = 19807
const val weaponMurgleis_19823 = 19823
const val weaponBurtgang_19825 = 19825
const val weaponTizona_19834 = 19834
const val weaponExcalibur_19841 = 19841
const val weaponAlmace_19855 = 19855
const val weaponBrunello_19875 = 19875
const val weaponKhadga_19876 = 19876
const val weaponShikargar_19877 = 19877
const val weaponThibron_19878 = 19878
const val weaponMurgleis_19952 = 19952
const val weaponBurtgang_19954 = 19954
const val weaponTizona_19963 = 19963
const val weaponChastisers_20523 = 20523
const val weaponSangarius_20611 = 20611
const val weaponSangarius1_20612 = 20612
const val weaponPukulatmuj_20613 = 20613
const val weaponPukulatmuj1_20614 = 20614
const val weaponExcalibur_20645 = 20645
const val weaponExcalibur_20646 = 20646
const val weaponMurgleis_20647 = 20647
const val weaponMurgleis_20648 = 20648
const val weaponBurtgang_20649 = 20649
const val weaponBurtgang_20650 = 20650
const val weaponTizona_20651 = 20651
const val weaponTizona_20652 = 20652
const val weaponAlmace_20653 = 20653
const val weaponAlmace_20654 = 20654
const val weaponKamlanautsSword_20665 = 20665
const val weaponBlizzardBrand_20666 = 20666
const val weaponBlizzardBrand1_20667 = 20667
const val weaponFiretongue_20668 = 20668
const val weaponFiretongue1_20669 = 20669
const val weaponMacana_20670 = 20670
const val weaponIceBrand_20672 = 20672
const val weaponFlametongue_20673 = 20673
const val weaponAernSword_20674 = 20674
const val weaponAernSwordII_20675 = 20675
const val weaponColada_20677 = 20677
const val weaponFirangi_20678 = 20678
const val weaponTanmogayi_20679 = 20679
const val weaponTanmogayi1_20680 = 20680
const val weaponFlyssa_20681 = 20681
const val weaponFlyssa1_20682 = 20682
const val weaponZantetsuken_20683 = 20683
const val weaponExcalibur_20685 = 20685
const val weaponMurgleis_20686 = 20686
const val weaponBurtgang_20687 = 20687
const val weaponTizona_20688 = 20688
const val weaponAlmace_20689 = 20689
const val weaponReikiko_20690 = 20690
const val weaponKyukoto_20691 = 20691
const val weaponFermionSword_20694 = 20694
const val weaponSequence_20695 = 20695
const val weaponCombuster_20696 = 20696
const val weaponCombuster1_20697 = 20697
const val weaponFetteringBlade_20698 = 20698
const val weaponKoboto_20699 = 20699
const val weaponNixxer_20700 = 20700
const val weaponIris_20701 = 20701
const val weaponEmissary_20702 = 20702
const val weaponDeaconSaber_20703 = 20703
const val weaponDeaconSword_20704 = 20704
const val weaponBrilliance_20705 = 20705
const val weaponVampirism_20706 = 20706
const val weaponMedeinaKilij_20707 = 20707
const val weaponDemersalDegen_20708 = 20708
const val weaponDemersDegen1_20709 = 20709
const val weaponNibiruBlade_20710 = 20710
const val weaponBlurredSword_20711 = 20711
const val weaponBlurredSword1_20712 = 20712
const val weaponExcalipoor_20713 = 20713
const val weaponExcalipoorII_20714 = 20714
const val weaponAcclimator_20715 = 20715
const val weaponPerfervidSword_20716 = 20716
const val weaponArendsiFleuret_20717 = 20717
const val weaponClaidheamhSoluis_20718 = 20718
const val weaponHomesteadBlade_20719 = 20719
const val weaponEgeking_20720 = 20720
const val weaponMimesis_20721 = 20721
const val weaponUsonmunku_20722 = 20722
const val weaponDijaSword_20723 = 20723
const val weaponDijaSword1_20724 = 20724
const val weaponIztaasu2_20725 = 20725
const val weaponEminentScimitar_20726 = 20726
const val weaponTabahiFleuret_20727 = 20727
const val weaponKheshigBlade_20728 = 20728
const val weaponVivifiante_20729 = 20729
const val weaponPredatrice_20730 = 20730
const val weaponXiutleato_20731 = 20731
const val weaponBrunello1_20732 = 20732
const val weaponAnaheraSaber_20733 = 20733
const val weaponAnaheraSword_20734 = 20734
const val weaponCamaBlade_20735 = 20735
const val weaponIztaasu1_20736 = 20736
const val weaponForefrontBlade_20737 = 20737
const val weaponBuramenkah_20738 = 20738
const val weaponHalachuinicSword_20739 = 20739
const val weaponCamatlatia_20740 = 20740
const val weaponCoalitionBlade_20741 = 20741
const val weaponIztaasu_20742 = 20742
const val weaponBihkahSword1_20743 = 20743
const val weaponBihkahSword_20744 = 20744
const val weaponRouter_20847 = 20847
const val weaponAnnealedLance_20938 = 20938
const val weaponHalakaala_21340 = 21340
const val weaponLeafkinGrenade_21346 = 21346
const val weaponNarmarBoomerang_21348 = 21348
const val weaponWingcutter_21349 = 21349
const val weaponWingcutter1_21350 = 21350
const val weaponRoppoShuriken_21351 = 21351
const val weaponRoppoShuriken1_21352 = 21352
const val weaponHappoShuriken_21353 = 21353
const val weaponHappoShuriken1_21354 = 21354
const val weaponHachiyaShuriken_21355 = 21355
const val weaponSuppaShuriken_21356 = 21356
const val weaponTogakushiShuriken_21357 = 21357
const val weaponBestasBane_21368 = 21368
const val weaponAlbinBane_21390 = 21390
const val weaponSekiShuriken_21391 = 21391
const val weaponArasySword_21604 = 21604
const val weaponArasySword1_21605 = 21605
const val weaponEnrichingSword_21606 = 21606
const val weaponEnrSword1_21607 = 21607
const val weaponOnionSwordII_21608 = 21608
const val weaponSavetheQueenII_21609 = 21609
const val weaponHepatizonRapier_21610 = 21610
const val weaponHepRapier1_21611 = 21611
const val weaponRaeticBlade_21612 = 21612
const val weaponRaeticBlade1_21613 = 21613
const val weaponHepatizonSapara_21614 = 21614
const val weaponHepSapara1_21615 = 21615
const val weaponTokkoSword_21617 = 21617
const val weaponAjjaSword_21618 = 21618
const val weaponElettaSword_21619 = 21619
const val weaponKajaSword_21620 = 21620
const val weaponNaegling_21621 = 21621
const val weaponVoluspaSword_21622 = 21622
const val weaponTwinnedBlade_21623 = 21623
const val weaponEtherealSword_21624 = 21624
const val weaponDuelistsSword_21625 = 21625
const val weaponVitiationSword_21626 = 21626
const val weaponCroceaMors_21627 = 21627
const val weaponValorSword_21628 = 21628
const val weaponCabalSword_21629 = 21629
const val weaponMoralltach_21630 = 21630
const val weaponMirageSword_21631 = 21631
const val weaponLuhlazaSword_21632 = 21632
const val weaponZomorrodnegar_21633 = 21633
const val weaponMalignanceSword_21635 = 21635
const val weaponNihility_21636 = 21636
const val weaponSakpatasSword_21637 = 21637
const val weaponExtinction_21638 = 21638
const val weaponOnionSwordIII_21640 = 21640
const val weaponSavetheQueenIII_21641 = 21641
const val weaponPrimeSword_21642 = 21642
const val weaponCaliburnus_21643 = 21643
const val weaponCaliburnus_21644 = 21644
const val weaponCaliburnus_21645 = 21645
const val weaponCaliburnus_21646 = 21646
const val weaponDathabaHanger_21647 = 21647
const val weaponJokushunoibuki_22256 = 22256
const val weaponGenmeinoibuki_22257 = 22257
const val weaponShukuyunoibuki_22258 = 22258
const val weaponKobonoibuki_22259 = 22259
const val weaponAntitail_22266 = 22266
const val weaponAntitail1_22267 = 22267
const val weaponPamamaPeel_22275 = 22275
const val weaponSasukeShuriken_22276 = 22276
const val weaponSasukeShuriken1_22277 = 22277
const val weaponGrudge_22282 = 22282
const val weaponDateShuriken_22292 = 22292
